export const FLIGHT_HOTEL = "flightHotel";
export const FLIGHT_HOTEL_CAR = "flightHotelCar";
export const FLIGHT_CAR = "flightCar";
